import { useEffect, useState } from 'react'
import { useCalendarContext } from '../components/calendar/CalendarContext'
import { BREAKPOINTS } from '../styles/dimensions'

const ULTRAWIDE_FULL_QUERY = `(min-width: ${BREAKPOINTS.ultrawideFull}px)`
const getIsUltrawideFull = () => window.matchMedia?.(ULTRAWIDE_FULL_QUERY).matches ?? false

// Week view hands the screen to the calendar, so list views drop their details pane and a second
// click on the selected row switches back to day view to show it. An ultrawide screen has room for
// list, details and the whole week side by side, so there the pane stays.
//
// Every task row reads this, so it listens with `matchMedia` (fires only when the threshold is
// crossed) rather than `useWindowSize` (re-renders on every resize event).
const useShowDetailsPane = () => {
    const { calendarType } = useCalendarContext()
    const [isUltrawideFull, setIsUltrawideFull] = useState(getIsUltrawideFull)

    useEffect(() => {
        const query = window.matchMedia?.(ULTRAWIDE_FULL_QUERY)
        if (!query) return
        setIsUltrawideFull(query.matches)
        const handleChange = (event: MediaQueryListEvent) => setIsUltrawideFull(event.matches)
        query.addEventListener('change', handleChange)
        return () => query.removeEventListener('change', handleChange)
    }, [])

    return calendarType === 'day' || isUltrawideFull
}

export default useShowDetailsPane
